<template>


  <div>

    <!-- {{categoria}} -->
    <!-- <hr></hr> -->
    <!-- {{categorias }} -->

    {{categoria}}

    
    <!-- {{vendedores}} -->



    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>



    <EditarCategoriaDialog ref="editarCategoriaDialog" @actualizado="despuesDeActualizar"></EditarCategoriaDialog>


    <!-- <h3>{{categoria}}</h3>  -->

    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Categorias</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">

        <v-tab href="#one">
          <v-icon left>mdi-account</v-icon>
          Registro
        </v-tab>

        <v-tab href="#two">
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
      </v-tabs>
      <v-tabs-items :value="tab">
        <!-- <div :value="tab"> -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>


                <v-text-field v-model="categoria.descripcion" label="Descripción" :counter="3" :rules="textRules"
                  required></v-text-field>


                     <v-text-field v-model="categoria.categoria_icon" label="Icono Categoria" 
                  ></v-text-field>


                <v-radio-group v-model="categoria.estado" row :rules="[v => !!v || 'Seleccione estado']"
                  aria-label="Estado de la categoría">
                  <v-radio label="Activo" value="activo"></v-radio>
                  <v-radio label="Inactivo" value="inactivo"></v-radio>
                </v-radio-group>

                <v-select v-model="categoria.vendedor" :items="vendedores" item-text="nombre" item-value="id"
                  label="Seleccionar vendedor" return-object outlined dense>
                  
                  
                  </v-select>






                <v-row no-gutters>

                  <v-col>
                  </v-col>

                  <v-col order="last">

                  </v-col>

                </v-row>



                <v-btn :disabled="!valid" color="success" class="mr-4" @click="registrar">
                  Registrar
                </v-btn>

                <v-btn color="error" class="mr-4" @click="reset();">
                  Cancelar
                </v-btn>

              </v-form>
            </v-card-text>


            <v-card-text>

              <v-alert colored-border type="info" elevation="2">
                El presente registro es responsable de almacenar información sobre el Categoria.<br>

              </v-alert>

            </v-card-text>




          </v-card>
        </v-tab-item>

        <!--  fin item 1-->
        <v-tab-item value="two">
          <v-card flat>
            <v-card-text>

              <v-text-field v-model="buscador" placeholder="Ejemplo: Juan Perez" outlined>
                <template v-slot:label>
                  <v-icon style="vertical-align: middle">
                    mdi-magnify
                  </v-icon>
                  Busqueda por descripcion de Categoria
                </template>


              </v-text-field>




              <v-simple-table fixed-header>
                <template v-slot:default>


                  <thead class="thead-dark">
                    <tr>

                      <th scope="col">Id</th>
                      <th scope="col">Descripción</th>
                      <th scope="col">Estado</th>
                      <th scope="col">Nombre Vendedor</th>
                      <th scope="col">Editar</th>
                      <th scope="col">Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="categoria in categoriasBuscados" :key="categoria.id">
                      <td>{{ categoria.id }}</td>


                      <td>{{ categoria.descripcion }}</td>


                      <td>{{ categoria.estado }}</td>


                      <td>{{ categoria.vendedor.nombre }}</td>



                      <td>
                        <!-- <button @click="editarCategoria(categoria)" class="btn"><v-icon left>mdi-pencil</v-icon></button> -->
                        <v-btn color="primary" @click="openEditarCategoriaDialog(categoria)">
                          <v-icon left>mdi-pencil</v-icon> Editar
                        </v-btn>
                      </td>
                      <td>
                        <button @click="eliminarCategoria(categoria)" class="btn"><v-icon
                            left>mdi-delete-forever</v-icon></button>
                      </td>

                    </tr>
                  </tbody>


                </template>
              </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

        <!--  fin item 2-->


      </v-tabs-items>

      <!-- </div> -->
    </v-card>

  </div>
</template>


<script>


import categoriaService from "@/services/tienda/categoriaService.js";


import vendedorService from "@/services/tienda/vendedorService.js";


import axios from 'axios'
import EditarCategoriaDialog from "@/components/tienda/categoria/EditarCategoriaDialog.vue";




export default {

  name: 'Categoria',
  components: { EditarCategoriaDialog },

  computed: {
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get() {
        return this.$route.query.tab
      }
    }
  },
  data: vm => ({

    

    mensaje: {
      snackbar: false,
      text: '',
      color: '',
      timeout: 5000,
    },

    categoriaSeleccionado: {},
    valid: true,
    tab: "",
    buscador: '',
    showPass: false,
     vendedores: [],
    categorias: [],
    categoria: {

      id: '',
      descripcion: '',
      estado: 'activo',
       categoria_icon: '',
      vendedor: null

    },














    rules: {
      required: value => !!value || 'Campo Requerido',
      min: v => v.length >= 5 || 'Minimo 5 caracteres'
    },
    messages: undefined,



    textRules: [
      (v) => !!v || "Campo es requerido",
      (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
    ],


  }),
  created() {

  }
  , mounted() {

    this.categoria.empresa_id = "1";
    this.categoria.estado = "activo";
    this.listarCategorias();

    this.tab = "two";


    this.listarVendedoresAdmin();


  },

  methods: {

    listarVendedoresAdmin() {
      vendedorService
        .listarVendedoresAdmin()
        .then((resposta) => {
          //    console.log(resposta.data);
          this.vendedores = resposta.data;
        })

    },

    despuesDeActualizar() {

      let mensajeText = 'Actualizado correctamente...';


      this.mensaje.text = mensajeText;

      this.mensaje.color = "success";
      this.mensaje.colorBtn = "green darken-1";

      this.mensaje.snackbar = "true";

      this.listarCategorias();


    },

    openEditarCategoriaDialog(categoria) {
      this.categoriaSeleccionado = { ...categoria }


      this.$refs.editarCategoriaDialog.openDialog(this.categoriaSeleccionado)


    },







    listarCategorias() {
      categoriaService
        .listarCategorias()
        .then((resposta) => {
          //    console.log(resposta.data);
          this.categorias = resposta.data;
        })

    },
    registrar() {
      if (this.$refs.form.validate()) {




        console.log(this.categoria);

        categoriaService.save(this.categoria, this.config).then(resposta => {
          this.limpiar();

          let mensajeText = 'Registro exitoso';
          this.mensaje.text = mensajeText;
          this.mensaje.color = "success";
          this.mensaje.colorBtn = "green darken-1";
          this.mensaje.snackbar = "true";

          this.listarCategorias();
          this.selectedTab = "second";
        }).catch((errors) => {

          let mensajeError = 'Ha ocurrido un error:\n';

          // Recorremos el array de errores del backend
          if (errors.response && errors.response.data && errors.response.data.errors) {
            errors.response.data.errors.forEach((err, index) => {
              mensajeError += `${index + 1}. ${err}\n`;
            });
          } else {
            mensajeError += 'Error desconocido';
          }

          // Asignamos al snackbar
          this.mensaje.text = mensajeError;
          this.mensaje.snackbar = true; // debe ser boolean
          this.mensaje.color = "error"; // fondo rojo
          this.mensaje.colorBtn = "red darken-2"; // color de botón contraste


        })

      }
    },
    editarCategoria(categoria) {


      this.categoria.id = categoria.id;
      this.categoria.descripcion = categoria.descripcion;
      this.categoria.estado = categoria.estado;
      this.tab = "one";

      console.log(categoria);

    },
    eliminarCategoria(categoria) {

      if (confirm('Desea remover al categoria')) {

        categoriaService.delete(categoria).then(resposta => {

          let mensajeText = 'Registro eliminado correctamente';
          this.mensaje.text = mensajeText;
          this.mensaje.color = "success";
          this.mensaje.colorBtn = "green darken-1";
          this.mensaje.snackbar = "true";



          this.listarCategorias();
          this.errors = []
          this.limpiar();

        }).catch(e => {

          this.errors = e.response.data.errors

        })

      }





    },
    limpiar() {


      this.categoria = {
        id: '',
        descripcion: '',
        estado: 'activo',
        categoria_icon: ''

      }


    },

    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  },

  watch: {
    date(val) {



    },
  },
  computed: {




    categoriasBuscados() {
      return this.categorias.filter(categoria => {
        return categoria.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
      });

    }






  },
};
</script>
